module.exports = __webpack_public_path__ + "static/img/pdan.e78f597.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/newCourse/pdan.png
// module id = 0IfO
// module chunks = 96